import { NgModule } from '@angular/core';
import { LabelPipe } from './label.pipe';

// Modulo reutilizavel pra disponibilizar o LabelPipe em features distintas
// sem precisar redeclarar em cada uma.
@NgModule({
  declarations: [LabelPipe],
  exports: [LabelPipe],
})
export class LabelModule {}
